import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	// No issues in version case.
	noIssuesInVersionHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesInVersionDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Non-text filter applied, no matching issues.
	noIssuesMatchFilterHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesMatchFilterDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	// Text filter applied, no matching issues.
	// Note that non-text filters may *also* be applied. These messages cover both cases.
	noIssuesMatchTextFilterHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesMatchTextFilterDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesInVersionDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesMatchFilterHeaderIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	// No issues in version case.
	noIssuesInVersionHeader: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-in-version-header',
		defaultMessage: 'Nothing to see here',
		description: 'Title that is shown when a version has no issues in it.',
	},
	noIssuesInVersionDescription: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description',
		defaultMessage: 'No issues have been added yet.',
		description: 'Description that is shown when a version has no issues in it.',
	},
	// Non-text filter applied, no matching issues.
	noIssuesMatchFilterHeader: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header',
		defaultMessage: 'No issues here',
		description:
			'Title that is shown when no issues in the version match the filter the user has applied.',
	},
	noIssuesMatchFilterDescription: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description',
		defaultMessage: "We didn't find any issues that match the filters you've chosen",
		description:
			'Description that is shown when no issues in the version match the filter the user has applied.',
	},
	// Text filter applied, no matching issues.
	// Note that non-text filters may *also* be applied. These messages cover both cases.
	noIssuesMatchTextFilterHeader: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-header',
		defaultMessage: 'We didn\'t find any results for "{textFilter}"',
		description:
			'Title that is shown when no issues in the version match the text filter the user has applied.',
	},
	noIssuesMatchTextFilterDescription: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-text-filter-description',
		defaultMessage: 'Try changing your search or check any filters.',
		description:
			'Description that is shown when no issues in the version match the text filter the user has applied.',
	},
	clearFilters: {
		id: 'software-releases-version-detail-issue-list.empty-view.clear-filters',
		defaultMessage: 'Clear filters',
		description:
			'Button text that when clicked removes the issue filters that have been applied to the table',
	},
	noIssuesInVersionDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-in-version-description-issue-terminology-refresh-m4',
		defaultMessage: 'No work items have been added yet.',
		description: 'Description that is shown when a version has no issues in it.',
	},
	noIssuesMatchFilterHeaderIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-header-issue-terminology-refresh-m4',
		defaultMessage: 'No work items here',
		description:
			'Title that is shown when no issues in the version match the filter the user has applied.',
	},
	noIssuesMatchFilterDescriptionIssueTerminologyRefreshM4: {
		id: 'software-releases-version-detail-issue-list.empty-view.no-issues-match-filter-description-issue-terminology-refresh-m4',
		defaultMessage: "We didn't find any work items that match the filters you've chosen",
		description:
			'Description that is shown when no issues in the version match the filter the user has applied.',
	},
});
export default messages;
